<template>
  <div class="bill-detail">
    <el-dialog
      title="结算详情"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :visible.sync="dialogVisible"
      :before-close="handleClose"
      width="700px"
    >
      <template v-if="workLogDataOne.length && [2,4,6].includes(info.auditStatus)">
        <div class="title">
          <span class="title_inside" />
          驳回原因
        </div>
        <el-input
          type="textarea"
          :rows="6"
          readonly
          placeholder="请输入内容"
          v-model="workLogDataOne[0].auditNote"
          style="margin-bottom: 24px"
        />
      </template>
      <div class="title">
        <span class="title_inside" />
        结算订单信息
      </div>
      <div v-loading="loading" class="content">
        <el-row type="flex" align="middle" class="content-line">
          <p class="label">结算单id：</p>
          <p class="value">{{ info.id }}</p>
        </el-row>
        <el-row type="flex" align="middle" class="content-line">
          <p class="label">招生方名称：</p>
          <p v-if="info.isAgentFlag === 1" class="value">教务服务方 - {{ info.agentName }}</p>
          <p v-else-if="info.isAgentFlag === 2" class="value">招生服务方 - {{ info.distributionName }}</p>
          <p v-else class="value"> -- </p>
        </el-row>
        <el-row type="flex" align="middle" class="content-line">
          <p class="label">申请人：</p>
          <p class="value">{{ info.applyUserName }}</p>
        </el-row>
        <el-row type="flex" align="middle" class="content-line">
          <p class="label">申请时间：</p>
          <p class="value">{{ info.applyDate }}</p>
        </el-row>
        <el-row type="flex" align="middle" class="content-line">
          <p class="label">本次应结算总人次：</p>
          <p class="value">{{ info.applyOrderNum }}</p>
        </el-row>
        <el-row type="flex" align="middle" class="content-line">
          <p class="label">本次招生销售应支付结算金额：</p>
          <template>
            <p v-if="info.settleAmt || info.settleAmt === 0" class="value">{{ info.settleAmt }}</p>
            <p v-else class="value"> -- </p>
          </template>
        </el-row>
        <el-row type="flex" align="middle" class="content-line">
          <p class="label">应累计服务保证金额：</p>
          <p class="value">{{ info.accumulateServiceBond }}</p>
        </el-row>
      </div>

      <div class="title">
        <span class="title_inside" />
        审批流程
      </div>
      <template v-if="!workLogBool">
        <el-timeline  v-loading="loading">
          <el-timeline-item
            v-for="(activity, index) in workLogDataOne"
            :key="index"
            icon="el-icon-more"
            color="#4795f5"
            type="primary"
            size="large"
            :timestamp="activity.auditDate"
          >
            <div style="word-break: break-all">
              【{{ activity.companyName }}】
              <span style="margin-right: 16px">{{ activity.remarks }}<span v-if="![1,3,5].includes(activity.auditStatus)">, {{ activity.auditorName }}</span></span>
            </div>
          </el-timeline-item>
        </el-timeline>
      </template>
      <template v-else>
        <el-timeline  v-loading="loading">
          <el-timeline-item
            v-for="(activity, index) in workLogData"
            :key="index"
            :icon="index === 0 ? 'el-icon-more' : ''"
            :color="index === 0 ? '#4795f5' : ''"
            type="primary"
            size="large"
            :timestamp="activity.auditDate"
          >
            <div style="word-break: break-all">
              【{{ activity.companyName }}】
              <span style="margin-right: 16px">{{ activity.remarks }}<span v-if="![1,3,5].includes(activity.auditStatus)">, {{ activity.auditorName }}</span></span>
            </div>
          </el-timeline-item>
        </el-timeline>
      </template>
      <div
        v-if="workLogData.length > 1"
        class="show_box"
        @click="workLogBool = !workLogBool"
      >
        {{ workLogBool ? "收起" : "展开" }}
      </div>
      <span slot="footer" class="dialog-footer">
        <template v-if="[1,3,5, 7].includes(info.auditStatus) && showOperate">
          <el-button :loading="loading" type="primary" size="small" @click="handleAffirm">{{ identityLabel }}通过</el-button>
          <el-button :loading="loading" size="small" @click="toReject">{{ identityLabel }}驳回</el-button>
        </template>
        <el-button :loading="loading" size="small" @click="handleClose">关 闭</el-button>
        <el-button v-if="!isEnd" :loading="loading" type="primary" size="small" @click="toNext">下一单</el-button>
      </span>
    </el-dialog>
    <!-- 驳回弹窗 -->
    <el-dialog
      :title="`${identityLabel}驳回`"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :visible.sync="dialogVisibleReject"
      :before-close="handleCloseReject"
      width="540px"
    >
      <el-input
        type="textarea"
        v-model.trim="auditNote"
        :rows="4"
        :maxlength="300"
        show-word-limit
        placeholder="请输入驳回原因"
      />
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="handleCloseReject">取 消</el-button>
        <el-button :loading="loading" type="primary" size="small" @click="handleConfirm">确认</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import {
  getBillDetails,
  billOrderAudit
} from "@/api/orderAdmin/orderList";
import { processing } from "@/utils/handle.js";

export default {
  name: 'BillDetail',

  props: {
    filter: {
      type: Object,
      default: () => {}
    },
    applyDate: {
      type: Array,
      default: () => []
    }
  },
  data () {
    return {
      dialogVisible: false,
      loading: false,
      info: {},
      workLogData: [],
      workLogDataOne: [],
      workLogBool: false,
      isEnd: false,
      dialogVisibleReject: false,
      auditNote: ''
    }
  },
  computed: {
    showOperate () {
      switch (this.info.auditStatus) {
        case 1:
        case 2:
          return this.$myStore.state.user.userIdentity === 1
        case 3:
        case 4:
        case 5:
        case 6:
        case 7:
          return this.$myStore.state.user.userIdentity === 0
      }
      return false
    },
    identityLabel () {
      let t = ''
      switch (this.info.auditStatus) {
        case 1:
          t = '教务服务方初审'
          break
        case 3:
          t = '教务复审'
          break
        case 5:
          t = '财务复审'
          break
        case 7:
          t = '项目负责人复审'
          break
      }
      return t
    }
  },
  methods: {
    init (id) {
      this.handleGetDetail(id)
      this.dialogVisible = true
    },
    handleGetDetail (id, isNext = false) {
      this.loading = true
      let params = { id }
      if (isNext) {
        params = {
          id,
          ...this.filter
        }
        if (this.applyDate && this.applyDate.length !== 0)  {
          params.applyStartDate = this.applyDate[0]
          params.applyEndDate = this.applyDate[1]
        }
        params.flag = this.$myStore.state.user.userIdentity
        this.info = {}
      }
      getBillDetails(processing(params), isNext).then(({ code, data }) => {
        if (code === 0) {
          if (data) {
            this.info = data
            if (data.audits) {
              this.workLogData = data.audits
              if (data.audits.length > 0) {
                this.workLogDataOne = [data.audits[0]]
              }
            }
          } else {
            this.$message.warning('已经是最后一条数据了!')
            this.isEnd = true
          }
        }
      }).finally(() => {
        this.loading = false
      })
    },
    // 通过审批
    handleAffirm () {
      const labelText = `${this.identityLabel}通过`
      this.$confirm(`是否确认${labelText}?`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        const params = {
          status: 1,
          balanceId: this.info.id
        }
        this.loading = true
        billOrderAudit(params).then(({ code }) => {
          if (code === 0) {
            this.$message.success(`${labelText}成功!`)
            this.handleGetDetail(this.info.id)
            this.$emit('refresh')
          }
        }).finally(() => {
          this.loading = false
        })
      })
    },
    // 点击驳回
    toReject () {
      this.dialogVisibleReject = true
    },
    // 点击下一单
    toNext () {
      this.workLogData = []
      this.workLogDataOne = []
      this.workLogBool = false
      this.handleGetDetail(this.info.id, true)
    },
    // 确认驳回
    handleConfirm () {
      const params = {
        status: 2,
        balanceId: this.info.id,
        auditNote: this.auditNote
      }
      this.loading = true
      billOrderAudit(params).then(({ code }) => {
        if (code === 0) {
          this.$message.success(`${this.identityLabel}成功!`)
          this.handleCloseReject()
          this.handleGetDetail(this.info.id)
          this.$emit('refresh')
        }
      }).finally(() => {
        this.loading = false
      })
    },
    handleClose () {
      this.info = {}
      this.workLogData = []
      this.workLogDataOne = []
      this.workLogBool = false
      this.isEnd = false
      this.dialogVisible = false
    },
    handleCloseReject () {
      this.auditNote = ''
      this.dialogVisibleReject = false
    }
  }
}
</script>

<style lang="scss" scoped>
.bill-detail {
  ::v-deep .el-dialog__body {
    padding: 16px 40px 30px 30px;
  }
  .title {
    font-size: 18px;
    display: flex;
    align-items: center;
    margin-bottom: 22px;
    margin-left: 2px;
    color: #333;
    .title_inside {
      display: inline-block;
      width: 4px;
      height: 18px;
      background: #4795f5;
      margin-right: 6px;
    }
  }
  .show_box {
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    border: 1px solid #ebebeb;
    border-radius: 6px;
    padding: 8px 0;
    font-size: 14px;
    margin-bottom: 30px;
    background-color: #ffffff;
  }
  .show_box:hover {
    background-color: #f9fafc;
  }
}
.content {
  margin-bottom: 24px;
}
.content-line {
  padding: 8px 0;
  font-size: 14px;
  color: #333;
  .label {
    width: 160px;
    text-align: right;
  }
  .value {
    margin-left: auto;
  }
}
</style>
